export default function PaymentConfirmationModal({ status, order, mpesaPhone, onClose }) {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4">
      <div className="bg-card rounded-lg shadow-xl max-w-md w-full p-6 relative">
        {/* Initiating State */}
        {status === 'initiating' && (
          <div className="text-center py-8">
            <div className="w-16 h-16 border-4 border-border border-t-primary
                            rounded-full animate-spin mx-auto mb-4"></div>
            <h3 className="text-xl font-bold text-foreground mb-2">
              Initiating Payment...
            </h3>
            <p className="text-muted-foreground text-sm">
              Please wait while we connect to M-Pesa
            </p>
          </div>
        )}

        {/* Waiting for Payment State */}
        {status === 'waiting' && (
          <div className="text-center py-8">
            <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center
                            justify-center mx-auto mb-4 animate-pulse">
              <i className="ri-smartphone-line text-3xl text-primary"></i>
            </div>
            <h3 className="text-xl font-bold text-foreground mb-2">
              Check Your Phone
            </h3>
            <p className="text-muted-foreground text-sm mb-4">
              Enter your M-Pesa PIN to complete the payment
            </p>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
              <p className="text-sm text-blue-800">
                <i className="ri-information-line mr-2"></i>
                A payment prompt has been sent to your phone
                {mpesaPhone && (
                  <> ending in <strong>{mpesaPhone}</strong></>
                )}
              </p>
            </div>
            <div className="flex items-center justify-center gap-2 text-xs text-muted-foreground">
              <div className="w-2 h-2 bg-primary rounded-full animate-bounce"></div>
              <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
              <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0.4s' }}></div>
              <span className="ml-2">Waiting for confirmation...</span>
            </div>
          </div>
        )}

        {/* Success State */}
        {status === 'success' && (
          <div className="text-center py-8">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center
                            justify-center mx-auto mb-4">
              <i className="ri-check-line text-3xl text-green-600"></i>
            </div>
            <h3 className="text-xl font-bold text-foreground mb-2">
              Payment Successful!
            </h3>
            <p className="text-muted-foreground text-sm mb-4">
              Your order has been confirmed
            </p>
            <div className="text-sm text-muted-foreground">
              Redirecting to order details...
            </div>
          </div>
        )}

        {/* Failed State */}
        {status === 'failed' && (
          <div className="text-center py-8">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center
                            justify-center mx-auto mb-4">
              <i className="ri-close-line text-3xl text-red-600"></i>
            </div>
            <h3 className="text-xl font-bold text-foreground mb-2">
              Payment Failed
            </h3>
            <p className="text-muted-foreground text-sm mb-6">
              Your M-Pesa payment was not completed
            </p>
            <div className="space-y-3">
              <button
                onClick={onClose}
                className="w-full bg-primary text-white py-3 px-4 rounded-lg
                          hover:bg-[#D84315] transition-colors font-medium"
              >
                Try Again
              </button>
              <button
                onClick={() => navigate('/cart')}
                className="w-full border-2 border-border text-foreground py-3 px-4
                          rounded-lg hover:bg-muted transition-colors font-medium"
              >
                Return to Cart
              </button>
            </div>
          </div>
        )}

        {/* Close button (only show for failed or waiting state) */}
        {(status === 'failed' || status === 'waiting') && (
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Close"
          >
            <i className="ri-close-line text-2xl"></i>
          </button>
        )}
      </div>
    </div>
  );
}
